<template>
<div class="animated fadeIn">
    <div class="card">
      <div class="card-body">
          <div class="row m-0">
              <div role="group" class="b-form-group form-group col-sm-12">
                  <div class="form-row mb-4">
                      <div class="col-sm-6">
                      <b-form-fieldset v-bind:label="$t('TITLE')">
                          <inputvalidation :formerror="formError" name="title">
                          <b-form-input type="text" v-model="formData.title"></b-form-input>
                          </inputvalidation>
                      </b-form-fieldset>
                      </div>
                      <div class="col-sm-6">
                      <b-form-fieldset v-bind:label="$t('POSTDATE')">
                          <datepicker v-model="formData.postDate" name="postDate"></datepicker>
                      </b-form-fieldset>
                      </div>
                  </div>
                  <div class="form-row mb-4">
                      <div class="col-sm-6">
                        <b-form-fieldset v-bind:label="$t('IMAGE')">
                            <fileupload v-model="formData.file" :chooseLabel="$t('SELECTFILE')" />
                        </b-form-fieldset>
                      </div>
                      <div class="col-sm-3">
                          <button type="button" class="btn btn-add" style="margin-top:80px;" @click="selectPreviousImage(0)">
                          <!-- icon icon="plus"></icon --> {{$t('SELECTPREVIOUSIMAGE')}}
                          </button>
                      </div>
                      <div class="col-sm-3">
                          <button type="button" class="btn btn-add" style="margin-top:80px;" @click="selectPreviousImage(1)">
                          <!-- icon icon="plus"></icon --> {{$t('SELECTPREVIOUSIMAGEFORBLOG')}}
                          </button>
                      </div>
                  </div>
                  <div class="form-row">
                      <div class="col-sm-12">
                      <b-form-fieldset v-bind:label="$t('DESCRIPTION')">
                          <ckeditor :editor="editor" v-model="formData.description" :config="editorConfig"></ckeditor>
                      </b-form-fieldset>
                      </div>
                  </div>
              </div>
              <div class="col-sm-12">
                <div class="float-right">
                    <b-btn class="mt-3" variant="secondary-trans mr-4" @click="hideModal">{{$t('CANCEL')}}</b-btn>
                    <b-btn class="mt-3" variant="primary" @click="submitData(formData)">{{$t('SAVE')}}</b-btn>
                </div>
              </div>
          </div>
      </div>
    </div>
    <!-- PREVIOUS IMAGE BLOG -->
    <b-modal ref="formimagemodal" :title="$t('SELECTPREVIOUSIMAGE')" ok-title="submit" hide-footer size="lg" no-close-on-backdrop>
        <div class="d-block">
            <table class="table table-foursight table-striped table-hover table-sm">
              <thead>
                <tr>
                  <th>{{$t('IMAGE')}}</th>
                  <th>{{$t('IMAGENAME')}}</th>
                  <th>{{$t('UPLOADDATE')}}</th>
                </tr>
              </thead>
              <tbody>
                <template v-for="item in dataImages.root">
                  <tr aria-rowindex="1" class=" table-ellipsis" @click="onSelectImage(item)">
                    <td>
                         <img :src="item.src" :alt="item.fileName" height="42" width="42">
                    </td>
                    <td>{{item.fileName}}</td>
                    <td>{{item.fileDate}}</td>
                  </tr>
                </template>
              </tbody>
            </table>
        </div>
        <div class="text-right">
            <b-btn class="mt-3" variant="secondary-trans mr-4" @click="hideImageModal">{{$t('CANCEL')}}</b-btn>
            <b-btn class="mt-3" variant="primary" @click="selectImage()">{{$t('SAVE')}}</b-btn>
        </div>
    </b-modal>
</div>
</template>

<script>
import
{
  mapActions,
  mapGetters
}
from 'vuex'
import moment from 'moment';
import BlogApi from '@/api/cms/Blog'

import ClassicEditor from '@ckeditor/ckeditor5-editor-classic/src/classiceditor';
import EssentialsPlugin from '@ckeditor/ckeditor5-essentials/src/essentials';
import BoldPlugin from '@ckeditor/ckeditor5-basic-styles/src/bold';
import ItalicPlugin from '@ckeditor/ckeditor5-basic-styles/src/italic';
import Underline from '@ckeditor/ckeditor5-basic-styles/src/underline';
import LinkPlugin from '@ckeditor/ckeditor5-link/src/link';
import ParagraphPlugin from '@ckeditor/ckeditor5-paragraph/src/paragraph';

import Autoformat from '@ckeditor/ckeditor5-autoformat/src/autoformat';
import BlockQuote from '@ckeditor/ckeditor5-block-quote/src/blockquote';
import Heading from '@ckeditor/ckeditor5-heading/src/heading';
import Image from '@ckeditor/ckeditor5-image/src/image';
import ImageCaption from '@ckeditor/ckeditor5-image/src/imagecaption';
import ImageStyle from '@ckeditor/ckeditor5-image/src/imagestyle';
import ImageToolbar from '@ckeditor/ckeditor5-image/src/imagetoolbar';
import ImageUpload from '@ckeditor/ckeditor5-image/src/imageupload';
import ImageResize from '@ckeditor/ckeditor5-image/src/imageresize';
import Indent from '@ckeditor/ckeditor5-indent/src/indent';
import List from '@ckeditor/ckeditor5-list/src/list';
import MediaEmbed from '@ckeditor/ckeditor5-media-embed/src/mediaembed';
import PasteFromOffice from '@ckeditor/ckeditor5-paste-from-office/src/pastefromoffice';
import Table from '@ckeditor/ckeditor5-table/src/table';
import TableToolbar from '@ckeditor/ckeditor5-table/src/tabletoolbar';
import SimpleuploadPlugin from '../../../components/lib/customAploadAdapter/simpleupload'
import Alignment from '@ckeditor/ckeditor5-alignment/src/alignment';

export default
{
  name: 'Blog',
  data: function()
  {
    return {
      editor: ClassicEditor,
      editorConfig: {
          plugins: [
              EssentialsPlugin,
              BoldPlugin,
              ItalicPlugin,
              Underline,
              LinkPlugin,
              ParagraphPlugin,
              Autoformat,
              BlockQuote,
              Heading,
              Image,
              ImageCaption,
              ImageStyle,
              ImageToolbar,
              ImageUpload,
              ImageResize,
              Indent,
              List,
              MediaEmbed,
              PasteFromOffice,
              Table,
              TableToolbar,
              SimpleuploadPlugin,
              Alignment
          ],

          toolbar: {
              items: [
                  'ckfinder',
                  'heading',
                  '|',
                  'bold',
                  'italic',
                  'underline',
                  'link',
                  'bulletedList',
                  'numberedList',
                  'alignment',
                  '|',
                  'indent',
                  'outdent',
                  '|',
                  'imageUpload',
                  'blockQuote',
                  'insertTable',
                  'mediaEmbed',
                  'undo',
                  'redo'
              ]
          },
          image: {
            toolbar: [ 'imageTextAlternative', '|', 'imageStyle:alignLeft', 'imageStyle:alignCenter', 'imageStyle:alignRight' ],
            styles: [
              // This option is equal to a situation where no style is applied.
              'alignCenter',

              // This represents an image aligned to the left.
              'alignLeft',

              // This represents an image aligned to the right.
              'alignRight'
            ],
            resizeUnit: 'px'
          },
          mediaEmbed:
          {
            removeProviders: ['instagram', 'twitter', 'googleMaps', 'flickr', 'facebook'],
            previewsInData: true
          },
          table: {
            contentToolbar: [
              'tableColumn',
              'tableRow',
              'mergeTableCells'
            ]
          },
          simpleUpload: {
              uploadUrl: {url:'/Blog/uploadImage'}
          },
          language: 'en'
      },
      formError:
      {},
      formData:
      {
        title: '',
        postDate: null,
        description: '',
        imgSrc: ''
      },
      dataImages: {},
      forBlog: 0,
      selectedImages: ''
    }
  },
  created()
  {
    var me = this;
    if(me.$route.params.blogId != 'null')
    {
        me.getBlogDetails();
    }
  },
  methods:
  {
    async getBlogDetails()
    {
      var me = this;
      try
      {
        var data = await BlogApi.selectSingleRow(
        {
          'blogId': me.$route.params.blogId
        });
        if (data.error && data.error == true)
        {
          me.$notify.notice(data);
          me.loading = false;
          return;
        }

        me.formData = data.root;
      }
      catch (e)
      {
        me.$notify.notice(e);
      }
    },
    async submitData(item)
    {
        var me = this;
        try
        {
            if (typeof item.blogId != 'undefined')
            {
                item.id = item.blogId;
                delete(item.blogId);
            }

            item.postDate = moment(item.postDate).utc().format('YYYY-MM-DD');

            if(typeof item.file != 'object') delete(item.file);

            var data = await BlogApi.submitData(item);
            if (data.error)
            {
                me.$notify.notice(data);
                me.formError = data;
            }
            else
            {
                me.$notify.notice(data);
                me.hideModal();
            }
        }
        catch (e)
        {
            me.$notify.notice(e);
        }
    },
    hideModal()
    {
        var me = this;

        me.formData = {
            title: '',
            postDate: null,
            description: '',
            imgSrc: ''
        }

        me.$router.push(
        {
            path: `/cms/blog`
        });
    },
    async selectPreviousImage(key)
    {
      var me = this;
      try
      {
            var data = await BlogApi.selectImages();
            me.dataImages = data;
            me.forBlog = key;
            this.$refs.formimagemodal.show();
      }
      catch (error)
      {
          me.$notify.notice(error);
      }
    },
    hideImageModal()
    {
      this.$refs.formimagemodal.hide();
    },
    selectImage()
    {
      var me = this;

      if(me.forBlog == 0)
      {
          me.$set(me.formData, 'imgSrc', me.selectedImages);
          me.$set(me.formData, 'file', me.selectedImages);
      }
      else
      {
        me.addExistingImagetoEditor();
      }

      me.hideImageModal();
    },
    onSelectImage(val)
    {
      var me = this;
      me.selectedImages = val.src;
    },
    addExistingImagetoEditor()
    {
      var me = this;
      me.formData.description += '<figure class="image"><img src="'+me.selectedImages+'"></figure>';
    }
  },
  watch:
  {

  }
}
</script>
